module.exports = __webpack_public_path__ + "/images/shop/icon/business_to_business_invoice.svg";